var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDataGreen = function SvgDataGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.384 17.22L5.811 20.994c-.958.236-1.677-.236-1.917-1.18L.061 4.483c-.24-.944.24-1.651 1.198-1.887L11.801 0c.48 0 .719 0 1.198.236l3.114 1.651 3.115 1.651c.48.236.719.472.719.944l2.635 10.85c.24.708-.24 1.652-1.198 1.888zm-14.614.236l12.458-2.83-2.156-8.493-2.396-1.415-2.396-1.18L3.894 5.19 6.77 17.456z",
    fill: "#96D7D6"
  })));
};
export default SvgDataGreen;